import { usePageMeta } from "@/lib/meta";
import Hero from "@/components/home/Hero";
import Marquee from "@/components/Marquee";
import Audiences from "@/components/home/Audiences";
import Outcomes from "@/components/home/Outcomes";
import Consultant from "@/components/home/Consultant";
import Services from "@/components/home/Services";
import CtaBand from "@/components/home/CtaBand";

export default function Home() {
  usePageMeta(
    "Credible Presence — Executive Voice & Communication Coaching | Austin, TX",
    "Executive voice coach and leadership communication coaching for executives, attorneys, senior leaders, and founders. Investor pitch coaching, startup pitch coaching, and founder pitch preparation — in person in Austin, TX and virtually worldwide."
  );

  return (
    <div data-testid="home-page">
      <Hero />
      <Marquee />
      <Audiences />
      <Outcomes />
      <Consultant />
      <Services />
      <CtaBand />
    </div>
  );
}
